interface Props {
  onStart: () => void;
}

export function Landing({ onStart }: Props) {
  return (
    <section className="screen landing">
      <div className="landing-top">
        <div className="brand-mark">去哪潜</div>
        <div className="brand-sub">找到属于你的下一片海</div>
      </div>
      <div className="landing-bottom">
        <div className="landing-headline">
          90 秒，
          <br />
          下次去哪潜水
          <br />
          有答案。
        </div>
        <button className="btn btn-primary" onClick={onStart}>开始测试</button>
        <div className="landing-tag">几个关于你的问题，几张可分享的卡片。</div>
      </div>
    </section>
  );
}
